import { useState, useRef, useEffect } from 'react';
import type { ZoomLevel, AggregatedDataPoint } from '../types';
import { CONFIG } from '../constants';

export const usePanningState = (
    zoomLevel: ZoomLevel,
    aggregatedData: AggregatedDataPoint[],
    isExpanded: boolean
) => {
    const [panOffset, setPanOffset] = useState(0);
    const [isDragging, setIsDragging] = useState(false);
    const [tempOffset, setTempOffset] = useState<number | null>(null);
    const [cursorPosition, setCursorPosition] = useState({ x: 0, y: 0 });
    const dragStartX = useRef(0);
    const dragStartOffset = useRef(0);

    // Auto-position to show most recent data when zoom level changes
    useEffect(() => {
        const windowSizes = isExpanded ? CONFIG.EXPANDED_WINDOW_SIZES : CONFIG.WINDOW_SIZES;
        const windowSize = windowSizes[zoomLevel];
        if (aggregatedData.length > windowSize) {
            const maxOffset = aggregatedData.length - windowSize;
            setPanOffset(maxOffset);
        } else {
            setPanOffset(0);
        }
    }, [zoomLevel, aggregatedData.length, isExpanded]);

    return {
        panOffset,
        setPanOffset,
        isDragging,
        setIsDragging,
        tempOffset,
        setTempOffset,
        cursorPosition,
        setCursorPosition,
        dragStartX,
        dragStartOffset,
    };
};
